import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HotelFiltersService } from '@app/services/hotelfilters.service';

@Component({
    selector: 'clever-preisalarme',
    templateUrl: './preisalarme.component.html',
    styleUrls: ['./preisalarme.component.scss'],
    standalone: false
})
export class PreisalarmeComponent implements OnInit {
    preisAlarm: boolean = false;
    isBrowser: boolean = false;
    destroyRef = inject(DestroyRef);
    constructor(
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    checkPra(ev): void {
        ev?.stopPropagation();
        ev?.preventDefault();
        if (!this.preisAlarm) {
            this.hotelService.setOpenPreisAlarmModal$(true);
        }
    }

    checkPratogel(): void {
        if (this.preisAlarm) {
            this.hotelService.setOpenPreisAlarmModal$(true);
        }
    }

    initFilterSub(): void {
        this.hotelService.preisAlarm$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((val: boolean) => {
            this.preisAlarm = val;
            this.cdr.markForCheck();
        });
    }

    async gotoPreisAlarm() {
        this.hotelService.gotoPreisAlarm();
    }
}
